// 全部用户
import {queryHrList} from '@api/hr/hr';

// 按模块的action, reducer整合体
const HR_SEARCH = 'HR_SEARCH';

export function getHrSearch(params) {
  return (dispatch, getState) => {
    const { hr_search: search } = getState();
    if (search.length > 0) {
      return dispatch({
        type: HR_SEARCH,
        data: search,
      });
    }
    return queryHrList({ ...params, status: 1 }).then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: HR_SEARCH,
          data: res.data,
        });
      }
    });
  };
}

export function hrSearch(state = [], action) {
  switch (action.type) {
    case HR_SEARCH:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hr_search.js